import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import ConfigHeading from '../configure/components/ConfigHeading';
import { requestPurchaseHistory } from '../../../state/ui/purchase/purchaseCreditsUiActions';
import { selectPurchaseHistoryRequest } from '../../../state/ui/purchase/purchaseCreditsUiReducer';
import { selectPurchaseHistory } from '../../../state/domain/purchases/purchaseHistoryReducer';
import PurchasesTable from './PurchasesTable';

function PurchaseHistory({
  isLoading, loadPageData, purchases,
}) {
  useEffect(() => {
    loadPageData();
  }, [loadPageData]);

  return (
    <Layout className="via-centre via-layout-configure-main">
      <ConfigHeading
        border="none"
        titleId="purchaseHistory"
        descriptionId="purchaseHistoryDesc"
      >
        <PurchasesTable
          isLoading={isLoading}
          purchases={purchases}
          viewInvoice="invoice"
        />
      </ConfigHeading>
    </Layout>
  );
}

// Validate the prop type parameters.
PurchaseHistory.propTypes = {
  isLoading: PropTypes.bool,
  loadPageData: PropTypes.func.isRequired,
  purchases: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      purchaseDateTime: PropTypes.string.isRequired,
      packageTitle: PropTypes.string.isRequired,
      purchaseStatus: PropTypes.string.isRequired,
      currencyCode: PropTypes.string.isRequired,
      mainTokens: PropTypes.number.isRequired,
      extraTokens: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      tokensRemaining: PropTypes.number.isRequired,
      vatCharge: PropTypes.number,
      expiryDate: PropTypes.string,
    }),
  ),
};

PurchaseHistory.defaultProps = {
  isLoading: false,
  purchases: [],
};

/**
 * A function for connecting redux state to the component props.
 */
const mapStateToProps = (state) => {
  const pageDataRequest = selectPurchaseHistoryRequest(state);

  return {
    isLoading: pageDataRequest ? pageDataRequest.isLoading : false,
    purchases: selectPurchaseHistory(state),
  };
};

/**
 * A function for connecting redux action to the component props.
 */
const mapDispatchToProps = dispatch => ({
  loadPageData: () => dispatch(requestPurchaseHistory()),
});

/**
 * Connect the redux state to our component.
 */
export default connect(mapStateToProps, mapDispatchToProps)(PurchaseHistory);
